// extracted by mini-css-extract-plugin
module.exports = {"loading-wrapper":"agreement_loading-wrapper__1SOqq"};